import { set, get, getMany, del, clear, keys, createStore, entries, setMany } from 'idb-keyval';
import { getStandardizedOptions } from './utilities';
/**
 * provides a storage wrapper for indexeddb access
 */
export class IndexedDBStorage {
    constructor(appName, storeName) {
        this.store = createStore(appName, storeName);
    }
    /**
     * checks if the browser supports indexeddb,
     * standard check is to look for indexedDB prop on window,
     */
    static isSupported() {
        return !!('indexedDB' in window && window.indexedDB);
    }
    async set(key, value, expiryOrOptions) {
        const { expiry, persist } = getStandardizedOptions(expiryOrOptions !== null && expiryOrOptions !== void 0 ? expiryOrOptions : {});
        return set(key, { value, expiry, persist }, this.store);
    }
    async get(key) {
        var _a;
        const { value } = (_a = (await get(key, this.store))) !== null && _a !== void 0 ? _a : {
            value: undefined,
        };
        return value;
    }
    async getMany(dbKeys) {
        const values = await getMany(dbKeys, this.store);
        return dbKeys.reduce((valuesFromStorage, key, index) => {
            var _a;
            valuesFromStorage[key] = (_a = values[index]) === null || _a === void 0 ? void 0 : _a.value;
            return valuesFromStorage;
        }, {});
    }
    async remove(key) {
        return del(key, this.store);
    }
    async clear() {
        const persistentEntries = new Array();
        const allEntries = await entries(this.store);
        for (const [key, val] of allEntries) {
            if (val.persist) {
                persistentEntries.push([key, val]);
            }
        }
        await clear(this.store);
        await setMany(persistentEntries, this.store);
    }
    async isExpired(key) {
        var _a;
        const { expiry } = (_a = (await get(key, this.store))) !== null && _a !== void 0 ? _a : {};
        return typeof expiry === 'undefined' ? expiry : Date.now() >= expiry;
    }
    async getAllKeys() {
        const allKeys = await keys(this.store);
        return allKeys;
    }
}
